import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '2079354',
  title: 'Tipos de Gráficos',
  video: { platform: 'youtube', videoId: 'Afh65T1n6T8' },
  article: [
    'Aula sobre tipos de gráficos mais usados em plataformas de trading.',
  ],
};

export default lesson;

